<div class="text-wrapper">
  <ng-content />
</div>
